var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPalestine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 10.4456H31.0045C28.7438 4.35274 22.8791 0.0107422 15.9997 0.0107422C11.5813 0.0107422 7.58177 1.80193 4.68652 4.69755L9.73884 10.4456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 21.5759H31.0045C28.7438 27.6687 22.8791 32.0107 15.9997 32.0107C11.5813 32.0107 7.58177 30.2196 4.68652 27.3239L9.73884 21.5759Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68622 4.69702C-1.56215 10.9454 -1.56215 21.0761 4.68622 27.3245C7.26828 24.7425 9.75159 22.2591 16 16.0108L4.68622 4.69702Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPalestine);
export default __webpack_public_path__ + "static/media/flag_palestine.2e0bf77e88e758af42da51521c2cb5c8.svg";
export { ForwardRef as ReactComponent };